import { render, staticRenderFns } from "./detailInDialog.vue?vue&type=template&id=4f9afc88&"
import script from "./detailInDialog.vue?vue&type=script&lang=js&"
export * from "./detailInDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports